import * as React from "react";
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M7.828 10.972H20v2.057H7.828l5.364 5.517L11.778 20 4 12l7.778-8 1.414 1.454z" }));
export default SvgArrowLeft;
